import { render, staticRenderFns } from "./acts-editor-info.vue?vue&type=template&id=fdd462ec"
import script from "./acts-editor-info.vue?vue&type=script&lang=js"
export * from "./acts-editor-info.vue?vue&type=script&lang=js"
import style0 from "./acts-editor-info.vue?vue&type=style&index=0&id=fdd462ec&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports